import {
  labelDelete,
  labelUpdate,
  modalConfirmDeleteTopic,
  modalConfirmDeleteTopicSubtitlePart1,
  modalConfirmDeleteTopicSubtitlePart2,
  snackbarSummaryTopicDeleteSuccessSubTitlePart1,
  snackbarSummaryTopicDeleteSuccessSubTitlePart2,
  snackbarTopicDeleted,
} from "_constants";
import { useConfirmDialogExit } from "hooks";
import { Topic } from "interfaces";
import { PrimeIcons } from "primereact/api";
import { Button } from "primereact/button";
import { Menu } from "primereact/menu";
import { useSnackbar } from "providers/SnackbarProvider";
import { useRef } from "react";
import { deleteTopic } from "services";
import { setPageTopics } from "store/slicer/GestioneTopicsSlice";
import { useAppDispatch } from "store/store";

export const TopicsTableRowButtonActions = ({
  topic,
  editCallback,
}: {
  topic: Topic;
  editCallback: Function;
}) => {
  const dispatch = useAppDispatch();
  const { showSnackbar } = useSnackbar();
  const { showConfirmDialogDelete } = useConfirmDialogExit();
  const menuRight = useRef<any>(null);
  const items = [
    {
      label: labelUpdate,
      icon: PrimeIcons.PENCIL,
      command: () => {
        editCallback(topic);
      },
    },
    {
      label: labelDelete,
      icon: PrimeIcons.TRASH,
      className: "p-menu-item-custom delete-color",
      command: () => {
        showConfirmDialogDelete({
          title: modalConfirmDeleteTopic,
          subtitle: `${modalConfirmDeleteTopicSubtitlePart1}<span class="font-weight-700">${topic.name}</span>${modalConfirmDeleteTopicSubtitlePart2}`,
          rejectCallback: callDeleteTopic,
        });
      },
    },
  ];

  const callDeleteTopic = () => {
    deleteTopic(topic.id)
      .then((_) => {
        showSnackbar({
          severity: "success",
          summary: snackbarTopicDeleted,
          detail: `${snackbarSummaryTopicDeleteSuccessSubTitlePart1}${topic.name}${snackbarSummaryTopicDeleteSuccessSubTitlePart2}`,
          life: 5000,
        });
        dispatch(setPageTopics(-1));
        setTimeout(() => {
          dispatch(setPageTopics(1));
        }, 200);
      })
      .catch((_) => {});
  };

  return (
    <>
      <Menu
        model={items}
        popup
        ref={menuRight}
        id="popup_menu_right"
        className="p-menu-custom-logout"
        popupAlignment="right"
      />
      <Button
        icon={PrimeIcons.ELLIPSIS_V}
        text
        severity="secondary"
        onClick={(event) => menuRight?.current?.toggle(event)}
      />
    </>
  );
};
